export default __webpack_public_path__ + "src/images/packages/kruger-sunset-lodge/3db0692457f0cd7e040022b16f8f5191-1.jpg";